export default __webpack_public_path__ + "img/Cinnamomum_parthenoxylon.3da7dead.jpg";